import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Grid, TextField } from "@mui/material";

import { DrawerForm, DrawerFormSection } from "../../../../components/DrawerForm";
import { DRAWER_FORM_GRID_SPACING, drawerReadonlyFieldSx } from "../../../../lib/ui/dialogFormLayout";

const EditAnomalyGuideDialogBody = (item: unknown) => {
  const { t } = useTranslation();
  const dialogItem = (item ?? {}) as Record<string, unknown>;
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [classificationGuidance, setClassificationGuidance] = useState("");

  useEffect(() => {
    setCategory(typeof dialogItem.category === "string" ? dialogItem.category : "");
    setSubCategory(typeof dialogItem.subCategory === "string" ? dialogItem.subCategory : "");
    setClassificationGuidance(
      typeof dialogItem.classificationGuidance === "string"
        ? dialogItem.classificationGuidance
        : "",
    );
  }, [
    dialogItem.id,
    dialogItem.category,
    dialogItem.subCategory,
    dialogItem.classificationGuidance,
  ]);

  return (
    <DrawerForm>
      <DrawerFormSection title={t("anomalyGuides.form.category")}>
        <Grid container spacing={DRAWER_FORM_GRID_SPACING}>
          <Grid size={12}>
            <TextField
              fullWidth
              id="id"
              name="id"
              label={t("anomalyGuides.form.id")}
              variant="outlined"
              size="small"
              value={String(dialogItem.id || "")}
              slotProps={{ input: { readOnly: true } }}
              sx={drawerReadonlyFieldSx}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              id="category"
              name="category"
              label={t("anomalyGuides.form.category")}
              variant="outlined"
              size="small"
              value={category}
              onChange={(event) => setCategory(event.target.value)}
            />
          </Grid>
          <Grid size={6}>
            <TextField
              required
              fullWidth
              id="subCategory"
              name="subCategory"
              label={t("anomalyGuides.form.subcategory")}
              variant="outlined"
              size="small"
              value={subCategory}
              onChange={(event) => setSubCategory(event.target.value)}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              fullWidth
              id="classificationGuidance"
              name="classificationGuidance"
              label={t("anomalyGuides.form.classificationGuidance")}
              variant="outlined"
              size="small"
              multiline
              rows={6}
              value={classificationGuidance}
              onChange={(event) => setClassificationGuidance(event.target.value)}
            />
          </Grid>
        </Grid>
      </DrawerFormSection>
    </DrawerForm>
  );
};

export default EditAnomalyGuideDialogBody;
